<script lang="ts" setup>
import PayPageDefault from './components/PayPage.default.vue'
import { getPayPageConfig } from '@/composables/payment'

const config = getPayPageConfig()
const PayPage = PayPageDefault
</script>

<template>
  <div>
    <!-- 🔥 品牌专属页面组件 -->
    <PayPage :config="config" />
  </div>
</template>
